'use client';
import { EditorContextProvider } from '../context/EditorContext/EditorContext';
import {
    NotificationContextProvider,
    NotificationPanel,
} from '../context/NotificationContext/NotificationContext';
import { Publish } from '../site-settings/Publish';

export function Preview(props) {
    const { company_data } = props;

    return (
        <NotificationContextProvider>
            <EditorContextProvider global_data={company_data}>
                <div className="static z-50 flex h-20 w-full items-center justify-end gap-2 border-b-2 border-b-neutral-500 bg-white px-8">
                    <Publish />
                    <NotificationPanel className="max-w-[220px]" />
                </div>
            </EditorContextProvider>
        </NotificationContextProvider>
    );
}
